module.exports = __webpack_public_path__ + "static/media/login-bg3.18fb9b52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/login-bg3.jpg
// module id = 171
// module chunks = 0